import type { FC } from 'react'
import { Box, Typography, useTheme } from '@mui/material'
import { EventType } from '@/features/events/shared/types'
import { ToolHeader } from '../shared'
import { infoContainerSx, infoRowSx, labelSx, pathValueSx, patternValueSx } from './shared'

interface GlobContextRendererProps {
  readonly pattern: string
  readonly path?: string
}

export const GlobContextRenderer: FC<GlobContextRendererProps> = ({ pattern, path }) => {
  const theme = useTheme()

  return (
    <>
      <ToolHeader eventType={EventType.TOOL_PERMISSION_REQUEST} toolName="Glob" />

      <Box sx={infoContainerSx}>
        <Box sx={infoRowSx}>
          <Typography variant="caption" sx={labelSx}>
            Pattern:
          </Typography>
          <Typography variant="body2" sx={patternValueSx(theme)}>
            {pattern}
          </Typography>
        </Box>

        {path && (
          <Box sx={infoRowSx}>
            <Typography variant="caption" sx={labelSx}>
              Search path:
            </Typography>
            <Typography variant="body2" sx={pathValueSx(theme)}>
              {path}
            </Typography>
          </Box>
        )}
      </Box>
    </>
  )
}
